export const APP_NAME = 'Tippler';
export const APP_DESCRIPTION = 'Digital Signage for your business';
